import React, { useState, useEffect } from 'react';
import DashboardHeader from '../../../components/DashboardHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import { auth, db } from '../../../auth/firebase';
import { doc, updateDoc } from 'firebase/firestore';
import cacheManager from '../../../auth/cache_manager';
import { 
  FaPen,
  FaBookMedical,
  FaUserMd,
  FaLanguage,
  FaHospitalAlt,
  FaFlask
} from 'react-icons/fa';
import './experiences.css';

function Experiences() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // # Load theme preference from user data on initial render
  useEffect(() => {
    const loadThemePreference = async () => {
      if (auth.currentUser?.uid) {
        // # Try to get from cache first
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData && userData.themes && userData.themes.gen_theme !== undefined) {
          setIsDarkMode(userData.themes.gen_theme === 'dark');
        }
      }
    };
    
    loadThemePreference();
  }, []);

  // # Handle theme toggle
  const handleThemeToggle = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      
      // # Update theme in Firebase if user is logged in
      if (auth.currentUser?.uid) {
        // # Update the user document
        await updateDoc(doc(db, 'users', auth.currentUser.uid), {
          'themes.gen_theme': newTheme ? 'dark' : 'light'
        });
        
        // # Update cache manager
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData) {
          const updatedUserData = {
            ...userData,
            themes: {
              ...(userData.themes || {}),
              gen_theme: newTheme ? 'dark' : 'light'
            }
          };
          cacheManager.set(`user_${auth.currentUser.uid}`, updatedUserData);
        }
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };

  // # Define experience sections with icons and descriptions
  const experienceSections = [
    {
      title: 'USMLE Step 1',
      icon: <FaBookMedical className="ext_exp_section-icon" />,
      description: 'Read Step 1 success stories'
    },
    {
      title: 'USMLE Step 2',
      icon: <FaUserMd className="ext_exp_section-icon" />,
      description: 'Learn from Step 2 experiences'
    },
    {
      title: 'OET',
      icon: <FaLanguage className="ext_exp_section-icon" />,
      description: 'OET preparation and success stories'
    },
    {
      title: 'Clinical Rotations',
      icon: <FaHospitalAlt className="ext_exp_section-icon" />,
      description: 'Clinical rotation experiences and tips'
    },
    {
      title: 'Research',
      icon: <FaFlask className="ext_exp_section-icon" />,
      description: 'Research experience insights'
    }
  ];

  return (
    <div className={`ext_exp_page-container ${isDarkMode ? 'ext_exp_dark-mode' : ''}`}>
      <DashboardHeader isDarkMode={isDarkMode} onThemeToggle={handleThemeToggle} />
      
      <main className="ext_exp_main-content">
        <div className="ext_exp_header">
          <h1>Experiences & Discussion</h1>
          <p>Learn from the experiences of your fellow medical students and professionals</p>
        </div>

        <div className="ext_exp_sections-grid">
          {experienceSections.map((section, index) => (
            <div 
              key={index}
              className="ext_exp_section-card"
            >
              <div className="ext_exp_icon-container">
                {section.icon}
              </div>
              <h3>{section.title}</h3>
              <p>{section.description}</p>
              <div className="ext_exp_coming-soon">Coming Soon</div>
            </div>
          ))}
        </div>
      </main>

      <DashboardFooter isDarkMode={isDarkMode} />
    </div>
  );
}

export default Experiences; 